export default "__VITE_ASSET__ea11c1ec__"